// import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import {
  FETCH_SELF_FINANCIALS_GIQ_FAILURE,
  FETCH_SELF_FINANCIALS_GIQ_REQUEST,
  FETCH_SELF_FINANCIALS_GIQ_SUCCESS,
} from "../actions/selfFinancialsGiqActions";

const initialState = {
  records: [],
  recordsLoading: true,
  recordsError: null,
};

const selfFinancialsGiqReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SELF_FINANCIALS_GIQ_REQUEST:
      return { ...state, recordsLoading: true, payload: action.payload };
    case FETCH_SELF_FINANCIALS_GIQ_SUCCESS:
      return { ...state, recordsLoading: false, records: action.payload };
    case FETCH_SELF_FINANCIALS_GIQ_FAILURE:
      return { ...state, recordsLoading: false, recordsError: action.payload };
    // case RESET_ALL_ACCOUNT_STATE_DEPEN:
    //   return { ...state, recordsLoading: false, records: [] };
    default:
      return state;
  }
};

export default selfFinancialsGiqReducer;
